// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"ffbb4a81","750":"207e24b1","787":"b6279157"}[chunkId] + ".chunk.js";
};